'use strict';

var _ = require('lodash');
var angular = require('angular');
var PooledSeasonalityReviewCalendarDirective = function PooledSeasonalityReviewCalendarDirective(seasonalityReviewConstants) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/pooled-seasonality-review-calendar.html'),
    controller: 'PooledSeasonalityReviewCalendarController',
    scope: {
      calendarData: '=',
      demandTransparencyAttributes: '=',
      screen: '@'
    },
    link: function link(scope) {
      scope.indexChartVisible = function () {
        return scope.screenState.selectedTab === seasonalityReviewConstants.INDEX_ANALYSIS.VALUE;
      };
      scope.labelChartVisible = function () {
        return scope.screenState.selectedTab === seasonalityReviewConstants.SEASON_LABELS.VALUE;
      };
      scope.isDataReady = function () {
        return _.isArray(scope.rtps) && scope.rtps.length > 0;
      };
      scope.$on('pooled-seasonality:publish-profile-request', scope.publishCalendar);
      scope.$on('cog:pooled-seasonality-review-toolbar', scope.flowTypeChange);

      //Always scroll to the top when review screen is rendered
      angular.element('html, body').animate({
        scrollTop: 0
      });
    }
  };
};
PooledSeasonalityReviewCalendarDirective.$inject = ['PooledSeasonalityReviewConstants'];
module.exports = PooledSeasonalityReviewCalendarDirective;